export * as RemoteWorkspace from "./remote-workspace.js"

import { Schema } from "effect"
import { optional } from "./schema.js"

export const Connection = Schema.Struct({
  key: Schema.String,
  url: Schema.String,
  password: Schema.String,
  directory: Schema.String,
  subject: Schema.String,
  audience: Schema.String,
  workspaceID: Schema.String,
  expiresAt: Schema.Finite,
}).annotate({ identifier: "RemoteWorkspace.Connection" })
export interface Connection extends Schema.Schema.Type<typeof Connection> {}
export const Status = Schema.Struct({
  state: Schema.String,
  connection: optional(Connection),
}).annotate({ identifier: "RemoteWorkspace.Status" })
export interface Status extends Schema.Schema.Type<typeof Status> {}
export const Client = Schema.Struct({ clientID: Schema.String })
export const Resources = Schema.Struct({
  cpu: Schema.Int,
  memory_mib: Schema.Int,
  disk_mib: Schema.Int,
}).annotate({ identifier: "RemoteWorkspace.Resources" })
export interface Resources extends Schema.Schema.Type<typeof Resources> {}
export const SSH = Schema.Struct({
  state: Schema.Literals(["ready", "starting", "stopped", "error", "unavailable"]),
  host: optional(Schema.String),
  port: optional(Schema.Int),
  user: Schema.String,
  sudo: Schema.Literal("unrestricted"),
  host_key: optional(Schema.String),
  initial_key_fingerprint: optional(Schema.String),
  initial_key_download: optional(Schema.String),
  command: optional(Schema.String),
  reason: optional(Schema.String),
}).annotate({ identifier: "RemoteWorkspace.SSH" })
export interface SSH extends Schema.Schema.Type<typeof SSH> {}

// Explicit authenticated download only; never part of events or status.
export const InitialSSHKey = Schema.Struct({ filename: Schema.String, privateKey: Schema.String }).annotate({
  identifier: "RemoteWorkspace.InitialSSHKey",
})
export interface InitialSSHKey extends Schema.Schema.Type<typeof InitialSSHKey> {}

export const Details = Schema.Struct({
  id: optional(Schema.String),
  state: Schema.String,
  error: optional(Schema.String),
  resources: optional(Resources),
  pending_resources: optional(Resources),
  resource_error: optional(Schema.String),
  details: Schema.Struct({
    ssh: optional(SSH),
    image: Schema.String,
    build_id: Schema.String,
    directory: Schema.String,
    limits: Resources,
    observed_resources: optional(Resources),
    reserved_disk_mib: optional(Schema.Int),
    resizable: Schema.Boolean,
    backend_available: Schema.Boolean,
    idle_seconds: Schema.Int,
    background_seconds: Schema.Int,
    session_expires_at: optional(Schema.Finite),
    lease_expires_at: optional(Schema.Finite),
  }),
}).annotate({ identifier: "RemoteWorkspace.Details" })
export interface Details extends Schema.Schema.Type<typeof Details> {}
export const Resize = Schema.Struct({
  workspace_id: Schema.String,
  resources: Resources,
  restart: Schema.Literal(true),
})
export interface Resize extends Schema.Schema.Type<typeof Resize> {}
export const Connect = Schema.Struct({
  clientID: Schema.String,
  active: optional(Schema.Boolean),
  wake: optional(Schema.Boolean),
})
export class RequestError extends Schema.TaggedError<RequestError>()("RemoteWorkspace.RequestError", {
  code: Schema.String,
  message: Schema.String,
}) {}
